import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import Loadable from 'react-loadable';
import { toast } from 'react-toastify';
import { homePath } from '../lib/constants/links';
import Loading, { CircularLoading } from '../lib/components/Loading';
import PublicLayout from '../layout/PublicLayout';
import JWAdminLayout from '../layout/JWAdminLayout';
import {
  CircularLoadingJsonapi,
  CircularLoadingJsonapiV2,
} from '../lib/components/Loading';
import useSetApolloCache from './useSetApolloCache';

const loading = Loading;

const LoadableHomepage = Loadable({
  loader: () => import('../containers/Public/Homepage/HomepageContainer'),
  loading,
});
const LoadableBackgroundChecks = Loadable({
  loader: () =>
    import(
      '../components/Organizers/Checkr/BackgroundChecksMain/BackgroundChecksMain'
    ),
  loading,
});
const LoadableShowCandidate = Loadable({
  loader: () =>
    import('../components/Organizers/Checkr/ShowCandidate/ShowCandidate'),
  loading,
});
const LoadableOrgSignupSuccess = Loadable({
  loader: () => import('../components/Organizers/Signup/OrgSignupSuccess'),
  loading,
});

const LoadableJWAdminOrganizations = Loadable({
  loader: () =>
    import('appDir/components/JWAdmin/Organizations/OrganizationsMain'),
  loading,
});
const LoadableJWAdminEditOrganization = Loadable({
  loader: () =>
    import(
      'appDir/components/JWAdmin/Organizations/EditOrganization/EditOrganizationRoot'
    ),
  loading,
});
// const LoadableJsonapiTester = Loadable({
//   loader: () => import('appDir/components/JWAdmin/JsonapiTester/JsonapiTester'),
//   loading,
// });
// const LoadableOrganizationSettings = Loadable({
//   loader: () => import('appDir/components/Organizers/Settings/SettingsRoot'),
//   loading,
// });
// const LoadableContactLists = Loadable({
//   loader: () =>
//     import(
//       'appDir/components/Organizers/ContactLists/Index/ContactListsIndexRoot'
//     ),
//   loading,
// });
// const LoadableSearchContacts = Loadable({
//   loader: () =>
//     import('appDir/components/Organizers/Contacts/Search/SearchContactsRoot'),
//   loading,
// });
// const LoadableContacts = Loadable({
//   loader: () =>
//     import('appDir/components/Organizers/Contacts/Index/ContactsIndexRoot'),
//   loading,
// });
// const LoadableContact = Loadable({
//   loader: () =>
//     import('appDir/components/Organizers/Contacts/Show/ContactShowRoot'),
//   loading,
// });
// const LoadableMoveRegistrant = lazy(() =>
//   import('appDir/components/Organizers/Registrants/MoveRegistrantRoot')
// );
const NewStripePlanRoot = lazy(() =>
  import('appDir/components/Organizers/StripeSubscription/NewStripePlanRoot')
);
const EditStripePlanRoot = lazy(() =>
  import('appDir/components/Organizers/StripeSubscription/EditStripePlanRoot')
);
// const NewProgramRoot = lazy(() =>
//   import('appDir/components/Organizers/Programs/NewProgramRoot')
// );
const UpdatesRoot = lazy(() =>
  import('appDir/components/Organizers/Updates/UpdatesRoot')
);

const useToastFlash = flash => {
  React.useEffect(() => {
    if (flash) {
      flash.forEach(el => {
        const [type, message] = el;
        if (type === 'alert') {
          toast.error(message);
        } else if (type === 'notice') {
          toast.success(message);
        }
      });
    }
  }, []);
  return null;
};

const Routes = routeProps => {
  const cacheLoaded = useSetApolloCache(routeProps.railsContext);
  useToastFlash(routeProps.railsContext.flash);
  if (!cacheLoaded) return null;

  return (
    <Suspense fallback={<CircularLoading />}>
      <SnackbarProvider
        maxSnack={3}
        autoHideDuration={3000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Switch>
          {/* <Route
            exact
            path="/jsonapi/tester"
            component={LoadableJsonapiTester}
          /> */}
          <Route
            exact
            path="/admin/checkr"
            component={LoadableBackgroundChecks}
          />
          <Route
            exact
            path="/admin/checkr/candidates/:id"
            component={LoadableShowCandidate}
          />
          <Route
            exact
            path="/org/signup/success"
            component={LoadableOrgSignupSuccess}
          />
          {/* <Route
            exact
            path="/admin/settings"
            component={LoadableOrganizationSettings}
          /> */}
          {/* <Route
            exact
            path="/admin/contact_lists"
            component={LoadableContactLists}
          />
          <Route
            exact
            path="/admin/contact_lists/:contactListId/contacts"
            component={LoadableContacts}
          /> */}
          {/* <Route
            exact
            path="/admin/contacts/search"
            component={LoadableSearchContacts}
          /> */}
          {/* <Route
            exact
            path="/admin/registrants/:registrantId/move_to_program/:toProgramId"
            component={LoadableMoveRegistrant}
          />
          <Route exact path="/admin/contacts/:id" component={LoadableContact} /> */}
          <Route
            exact
            path="/admin/subscription/new"
            component={NewStripePlanRoot}
          />
          <Route
            exact
            path="/admin/subscription/edit"
            component={EditStripePlanRoot}
          />
          {/* <Route exact path="/admin/programs/new" component={NewProgramRoot} /> */}
          <Route
            exact
            path="/jwadmin/organizations"
            render={props => (
              <JWAdminLayout>
                <LoadableJWAdminOrganizations {...props} />
              </JWAdminLayout>
            )}
          />
          <Route
            exact
            path="/jwadmin/organizations/:id/edit"
            render={props => (
              <JWAdminLayout>
                <LoadableJWAdminEditOrganization {...props} />
              </JWAdminLayout>
            )}
          />
          <Route exact path="/admin/updates" component={UpdatesRoot} />
          <PublicLayout>
            <React.Fragment>
              <Route exact path={homePath} component={LoadableHomepage} />
            </React.Fragment>
          </PublicLayout>
        </Switch>
        <CircularLoadingJsonapi />
        <CircularLoadingJsonapiV2 />
      </SnackbarProvider>
    </Suspense>
  );
};

export default Routes;
